export default "__VITE_ASSET__DOXJw0os__"